export default __webpack_public_path__ + "static/media/Icon=Task Statuses.08bed17f.svg";